import { AuthLayout } from 'components/_layouts/Auth/AuthLayout';
import { LoginPage } from 'domains/Login/LoginPage/LoginPage';
import { SignUpPage } from 'domains/Login/SignUp/SignUp';
import { ResetPassword } from 'domains/Login/ResetPassword/ResetPassword';
import { NewPassword } from 'domains/Login/NewPassword/NewPassword';
import { RouterConfig } from '..';
import paths from 'shared/paths';

export const authRoutes: RouterConfig = [
    // Authorization Login
    {
        routes: [
            {
                component: LoginPage,
                exact: true,
                path: paths.login,
            },
        ],
        layoutComponent: AuthLayout,
    },
    {
        routes: [
            {
                component: SignUpPage,
                exact: true,
                path: paths.sign_up,
            },
        ],
        layoutComponent: AuthLayout,
    },
    {
        routes: [
            {
                component: ResetPassword,
                exact: true,
                path: paths.reset_password,
            },
        ],
        layoutComponent: AuthLayout,
    },
    {
        routes: [
            {
                component: NewPassword,
                exact: true,
                path: paths.new_password,
            },
        ],
        layoutComponent: AuthLayout,
    },
];
